import iconAdd from './add.svg';
import iconAddWith from './add-with.svg';
import iconArrow from './arrow.svg';
import iconBold from './bold.svg';
import iconCaret from './caret.svg';
import iconCheck from './check.svg';
import iconCircle from './circle.svg';
import iconClose from './close.svg';
import iconCode from './code.svg';
import iconCodeBlock from './code-block.svg';
import iconDragHandle from './drag-handle.svg';
import iconEye from './eye.svg';
import iconFolder from './folder.svg';
import iconGithub from './github.svg';
import iconGrid from './grid.svg';
import iconH1 from './h1.svg';
import iconH2 from './h2.svg';
import iconHome from './home.svg';
import iconImage from './image.svg';
import iconItalic from './italic.svg';
import iconLink from './link.svg';
import iconList from './list.svg';
import iconListBulleted from './list-bulleted.svg';
import iconListNumbered from './list-numbered.svg';
import iconMarkdown from './markdown.svg';
import iconMedia from './media.svg';
import iconMediaAlt from './media-alt.svg';
import iconNetlify from './netlify.svg';
import iconNetlifyCms from './netlify-cms-logo.svg';
import iconPage from './page.svg';
import iconPages from './pages.svg';
import iconPagesAlt from './pages-alt.svg';
import iconQuote from './quote.svg';
import iconScroll from './scroll.svg';
import iconSearch from './search.svg';
import iconSettings from './settings.svg';
import iconUser from './user.svg';
import iconWorkflow from './workflow.svg';
import iconWrite from './write.svg';

const images = {
  'add': iconAdd,
  'add-with': iconAddWith,
  'arrow': iconArrow,
  'bold': iconBold,
  'caret': iconCaret,
  'check': iconCheck,
  'circle': iconCircle,
  'close': iconClose,
  'code': iconCode,
  'code-block': iconCodeBlock,
  'drag-handle': iconDragHandle,
  'eye': iconEye,
  'folder': iconFolder,
  'github': iconGithub,
  'grid': iconGrid,
  'h1': iconH1,
  'h2': iconH2,
  'home': iconHome,
  'image': iconImage,
  'italic': iconItalic,
  'link': iconLink,
  'list': iconList,
  'list-bulleted': iconListBulleted,
  'list-numbered': iconListNumbered,
  'markdown': iconMarkdown,
  'media': iconMedia,
  'media-alt': iconMediaAlt,
  'netlify': iconNetlify,
  'netlify-cms': iconNetlifyCms,
  'page': iconPage,
  'pages': iconPages,
  'pages-alt': iconPagesAlt,
  'quote': iconQuote,
  'scroll': iconScroll,
  'search': iconSearch,
  'settings': iconSettings,
  'user': iconUser,
  'workflow': iconWorkflow,
  'write': iconWrite,
};

export default images;



// WEBPACK FOOTER //
// ./components/UI/Icon/images/_index.js